'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = buildRules;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// this file redefines all default rules found on http://tachyons.io/docs/
// as well as the flexbox rules https://github.com/tachyons-css/tachyons-flexbox

// list may look like
// [0, '1rem', '34px', 14] or {solid: 1, title: 1.25}
var buildRuleDict = function buildRuleDict(list, keyFn, styleKeys) {
  var intoDict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (Array.isArray(list)) {
    var _loop = function _loop(i) {
      var styleDict = Array.isArray(styleKeys) ? styleKeys.reduce(function (m, s) {
        m[s] = list[i];return m;
      }, {}) : _defineProperty({}, styleKeys, list[i]);
      intoDict[keyFn(i)] = styleDict;
    };

    for (var i = 0; i < list.length; i++) {
      _loop(i);
    }
  } else {
    Object.keys(list).forEach(function (label) {
      return intoDict[keyFn(label)] = _defineProperty({}, styleKeys, list[label]);
    });
  }
  return intoDict;
};

function buildRules(opts) {
  if (process.env.NODE_ENV !== 'production') {
    var missing = 'colors lineHeightScale typeSizeScale fontWeightScale boxShadows fontFamilies widthScale'.split(' ').filter(function (o) {
      return !opts[o];
    });
    if (missing.length) throw new Error('you need to pass "' + missing.join(', ') + '" within build options!');
    if (!opts.defaultScale) {
      var missingDefaults = 'paddingScale marginScale positionScale borderRadiusScale borderWidthScale'.split(' ').filter(function (o) {
        return !opts[o];
      });
      if (missingDefaults.length) throw new Error('If you don\'t pass a \'defaultScale\' you need to pass "' + missingDefaults.join(', ') + '" within build options!');
    }
  }
  var colors = opts.colors,
      typeSizeScale = opts.typeSizeScale,
      measureScale = opts.measureScale,
      lineHeightScale = opts.lineHeightScale,
      trackingScale = opts.trackingScale,
      fontWeightScale = opts.fontWeightScale,
      fontFamilies = opts.fontFamilies,
      _opts$paddingScale = opts.paddingScale,
      paddingScale = _opts$paddingScale === undefined ? opts.defaultScale : _opts$paddingScale,
      _opts$marginScale = opts.marginScale,
      marginScale = _opts$marginScale === undefined ? opts.defaultScale : _opts$marginScale,
      widthScale = opts.widthScale,
      _opts$maxWidthScale = opts.maxWidthScale,
      maxWidthScale = _opts$maxWidthScale === undefined ? widthScale : _opts$maxWidthScale,
      _opts$heightScale = opts.heightScale,
      heightScale = _opts$heightScale === undefined ? widthScale : _opts$heightScale,
      _opts$positionScale = opts.positionScale,
      positionScale = _opts$positionScale === undefined ? opts.defaultScale : _opts$positionScale,
      _opts$borderWidthScal = opts.borderWidthScale,
      borderWidthScale = _opts$borderWidthScal === undefined ? opts.defaultScale : _opts$borderWidthScal,
      _opts$borderRadiusSca = opts.borderRadiusScale,
      borderRadiusScale = _opts$borderRadiusSca === undefined ? opts.defaultScale : _opts$borderRadiusSca,
      boxShadows = opts.boxShadows;


  var rules = {};

  rules.typeScale = buildRuleDict(typeSizeScale, function (i) {
    return 'f' + (i + 1);
  }, 'font-size');

  rules.measure = {
    indent: { 'text-indent': '1em', 'margin-top': 0, 'margin-bottom': 0 },
    'small-caps': { 'font-variant': 'small-caps' },
    truncate: { 'white-space': 'nowrap', overflow: 'hidden', 'text-overflow': 'ellipsis' }
  };
  buildRuleDict(measureScale, function (i) {
    return 'measure' + (i ? '-' + i : '');
  }, 'max-width', rules.measure);

  rules.lineHeight = buildRuleDict(lineHeightScale, function (i) {
    return 'lh-' + i;
  }, 'line-height');

  rules.tracking = buildRuleDict(trackingScale, function (i) {
    return 'tracked' + (i ? '-' + i : '');
  }, 'letter-spacing');

  rules.fontWeight = {
    normal: { 'font-weight': 'normal' },
    b: { 'font-weight': 'bold' }
  };
  buildRuleDict(fontWeightScale, function (i) {
    return 'fw' + (i + 1);
  }, 'font-weight', rules.fontWeight);

  rules.fontStyle = {
    i: { 'font-style': 'italic' },
    'fs-normal': { 'font-style': 'normal' }
  };

  rules.verticalAlign = {
    'v-base': { 'vertical-align': 'baseline' },
    'v-mid': { 'vertical-align': 'middle' },
    'v-top': { 'vertical-align': 'top' },
    'v-btm': { 'vertical-align': 'bottom' }
  };

  rules.textAlign = {
    tl: { 'text-align': 'left' },
    tr: { 'text-align': 'right' },
    tc: { 'text-align': 'center' }
  };

  rules.textTransform = {
    ttc: { 'text-transform': 'capitalize' },
    ttl: { 'text-transform': 'lowercase' },
    ttu: { 'text-transform': 'uppercase' },
    ttn: { 'text-transform': 'none' }
  };

  rules.textDecoration = {
    strike: { 'text-decoration': 'line-through' },
    underline: { 'text-decoration': 'underline' },
    'no-underline': { 'text-decoration': 'none' }
  };

  rules.whiteSpite = {
    'ws-normal': { 'white-space': 'normal' },
    nowrap: { 'white-space': 'nowrap' },
    pre: { 'white-space': 'pre' }
  };

  rules.fontFamilies = {
    code: { 'font-family': 'Consolas, monaco, monospace', $global: true }
  };
  rules.fontFamilies = buildRuleDict(fontFamilies, function (i) {
    return i;
  }, 'font-family', rules.fontFamilies);

  rules.boxSizing = {
    'html, body, div, article, section, main, footer, header, form, fieldset, legend, pre, code, a, h1, h2, h3, h4, h5, h6, p, ul, ol, li, dl, dt, dd, textarea, table, td, th, tr, input[type="email"], input[type="number"], input[type="password"], input[type="tel"], input[type="text"], input[type="url"]': { 'box-sizing': 'border-box', $global: true },
    'border-box': { 'box-sizing': 'border-box' }
  };

  rules.spacing = {
    mla: { 'margin-left': 'auto' },
    mra: { 'margin-right': 'auto' },
    mba: { 'margin-bottom': 'auto' },
    mta: { 'margin-top': 'auto' },
    mva: { 'margin-top': 'auto', 'margin-bottom': 'auto' },
    mha: { 'margin-left': 'auto', 'margin-right': 'auto' }
  };

  [['p', 'padding', paddingScale], ['m', 'margin', marginScale]].forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 3),
        short = _ref3[0],
        long = _ref3[1],
        scale = _ref3[2];

    buildRuleDict(scale, function (i) {
      return short + 'a' + i;
    }, long, rules.spacing);

    buildRuleDict(scale, function (i) {
      return short + 'l' + i;
    }, long + '-left', rules.spacing);
    buildRuleDict(scale, function (i) {
      return short + 'r' + i;
    }, long + '-right', rules.spacing);
    buildRuleDict(scale, function (i) {
      return short + 'b' + i;
    }, long + '-bottom', rules.spacing);
    buildRuleDict(scale, function (i) {
      return short + 't' + i;
    }, long + '-top', rules.spacing);

    buildRuleDict(scale, function (i) {
      return short + 'v' + i;
    }, [long + '-top', long + '-bottom'], rules.spacing);
    buildRuleDict(scale, function (i) {
      return short + 'h' + i;
    }, [long + '-left', long + '-right'], rules.spacing);
  });

  rules.float = {
    fl: { float: 'left' },
    fr: { float: 'right' },
    fn: { float: 'none' }
  };

  rules.display = {
    dn: { display: 'none' },
    di: { display: 'inline' },
    db: { display: 'block' },
    dib: { display: 'inline-block' },
    dit: { display: 'inline-table' },
    dt: { display: 'table' },
    dtc: { display: 'table-cell' },
    'dt-row': { display: 'table-row' },
    'dt-row-group': { display: 'table-row-group' },
    'dt-column': { display: 'table-column' },
    'dt-column-group': { display: 'table-column-group' }
  };

  rules.color = buildRuleDict(colors, function (i) {
    return i;
  }, 'color');
  rules.backgroundColor = buildRuleDict(colors, function (i) {
    return 'bg-' + i;
  }, 'background-color');

  rules.width = {
    'w-10': { width: '10%' },
    'w-20': { width: '20%' },
    'w-25': { width: '25%' },
    'w-30': { width: '30%' },
    'w-33': { width: '33%' },
    'w-34': { width: '34%' },
    'w-40': { width: '40%' },
    'w-50': { width: '50%' },
    'w-60': { width: '60%' },
    'w-70': { width: '70%' },
    'w-75': { width: '75%' },
    'w-80': { width: '80%' },
    'w-90': { width: '90%' },
    'w-100': { width: '100%' },

    'w-third': { width: 'calc(100% / 3)' },
    'w-two-thirds': { width: 'calc(100% / 1.5)' },
    'w-auto': { width: 'auto' },
    'img': { 'max-width': '100%', $global: true }
  };
  buildRuleDict(widthScale, function (i) {
    return 'w' + (i + 1);
  }, 'width', rules.width);

  rules.maxWidth = {
    'mw-100': { 'max-width': '100%' }
  };
  buildRuleDict(maxWidthScale, function (i) {
    return 'w' + (i + 1);
  }, 'max-width', rules.maxWidth);

  rules.height = {
    'h-25': { height: '25%' },
    'h-50': { height: '50%' },
    'h-75': { height: '75%' },
    'h-100': { height: '100%' },
    'min-h-100': { 'min-height': '100%' },
    'vh-25': { height: '25vh' },
    'vh-50': { height: '50vh' },
    'vh-75': { height: '75vh' },
    'vh-100': { height: '100vh' },
    'min-vh-100': { 'min-height': '100vh' },
    'h-auto': { height: 'auto' },
    'h-inherit': { height: 'inherit' }
  };
  buildRuleDict(heightScale, function (i) {
    return 'h' + (i + 1);
  }, 'height', rules.height);

  rules.position = {
    static: { position: 'static' },
    relative: { position: 'relative' },
    absolute: { position: 'absolute' },
    fixed: { position: 'fixed' }
  };

  ['top', 'left', 'right', 'bottom'].forEach(function (dir) {
    buildRuleDict(positionScale, function (i) {
      return dir + '-' + i;
    }, dir, rules.position);
  });

  rules.backgroundSize = {
    cover: { 'background-size': 'cover' },
    contain: { 'background-size': 'contain' }
  };

  rules.borders = {
    ba: { 'border-style': 'solid', 'border-width': '1px' },
    bt: { 'border-top-style': 'solid', 'border-top-width': '1px' },
    br: { 'border-right-style': 'solid', 'border-right-width': '1px' },
    bb: { 'border-bottom-style': 'solid', 'border-bottom-width': '1px' },
    bl: { 'border-left-style': 'solid', 'border-left-width': '1px' },
    bn: { 'border-style': 'none', 'border-width': 0 },

    'b--dotted': { 'border-style': 'dotted' },
    'b--dashed': { 'border-style': 'dashed' },
    'b--solid': { 'border-style': 'solid' },
    'b--none': { 'border-style': 'none' }
  };
  buildRuleDict(colors, function (i) {
    return 'b--' + i;
  }, 'border-color', rules.borders);
  buildRuleDict(borderWidthScale, function (i) {
    return 'bw' + i;
  }, 'border-width', rules.borders);

  rules.borders = Object.assign({}, rules.borders, {
    'bt-0': { 'border-top-width': 0 },
    'br-0': { 'border-right-width': 0 },
    'bb-0': { 'border-bottom-width': 0 },
    'bl-0': { 'border-left-width': 0 }
  });

  rules.borderRadius = {
    'br-100': { 'border-radius': '100%' },
    'br-pill': { 'border-radius': '9999px' },
    'br--bottom': { 'border-top-left-radius': 0, 'border-top-right-radius': 0 },
    'br--top': { 'border-bottom-left-radius': 0, 'border-bottom-right-radius': 0 },
    'br--right': { 'border-top-left-radius': 0, 'border-bottom-left-radius': 0 },
    'br--left': { 'border-top-right-radius': 0, 'border-bottom-right-radius': 0 }
  };
  buildRuleDict(borderRadiusScale, function (i) {
    return 'br' + i;
  }, 'border-radius', rules.borderRadius);

  rules.boxShadow = buildRuleDict(boxShadows, function (i) {
    return 'shadow-' + i;
  }, 'box-shadow');

  rules.opacity = {
    'o-100': { opacity: 1 },
    'o-90': { opacity: .9 },
    'o-80': { opacity: .8 },
    'o-70': { opacity: .7 },
    'o-60': { opacity: .6 },
    'o-50': { opacity: .5 },
    'o-40': { opacity: .4 },
    'o-30': { opacity: .3 },
    'o-20': { opacity: .2 },
    'o-10': { opacity: .1 },
    'o-05': { opacity: .05 },
    'o-025': { opacity: .025 },
    'o-0': { opacity: 0 }
  };

  rules.list = {
    list: { 'list-style-type': 'none' }
  };

  rules.forms = {
    'input-reset': { '-webkit-appearance': 'none', '-moz-appearance': 'none' }
  };

  rules.flex = {
    flex: { display: 'flex' },
    'inline-flex': { display: 'inline-flex' },
    'flex-auto': { flex: '1 1 auto', 'min-width': 0 },
    'flex-none': { flex: 'none' },
    'flex-column': { 'flex-direction': 'column' },
    'flex-row': { 'flex-direction': 'row' },
    'flex-wrap': { 'flex-wrap': 'wrap' },
    'items-start': { 'align-items': 'flex-start' },
    'items-end': { 'align-items': 'flex-end' },
    'items-center': { 'align-items': 'center' },
    'items-baseline': { 'align-items': 'baseline' },
    'items-stretch': { 'align-items': 'stretch' },
    'self-start': { 'align-self': 'flex-start' },
    'self-end': { 'align-self': 'flex-end' },
    'self-center': { 'align-self': 'center' },
    'self-baseline': { 'align-self': 'baseline' },
    'self-stretch': { 'align-self': 'stretch' },
    'justify-start': { 'justify-content': 'flex-start' },
    'justify-end': { 'justify-content': 'flex-end' },
    'justify-center': { 'justify-content': 'center' },
    'justify-between': { 'justify-content': 'space-between' },
    'justify-around': { 'justify-content': 'space-around' },
    'content-start': { 'align-content': 'flex-start' },
    'content-end': { 'align-content': 'flex-end' },
    'content-center': { 'align-content': 'center' },
    'content-between': { 'align-content': 'space-between' },
    'content-around': { 'align-content': 'space-around' },
    'content-stretch': { 'align-content': 'stretch' },
    'order-0': { order: '0' },
    'order-1': { order: '1' },
    'order-2': { order: '2' },
    'order-3': { order: '3' },
    'order-4': { order: '4' },
    'order-5': { order: '5' },
    'order-6': { order: '6' },
    'order-7': { order: '7' },
    'order-8': { order: '8' },
    'order-last': { order: '99999' }
  };

  rules.cursor = {
    pointer: { cursor: 'pointer' }
  };

  return rules;
}


//////////////////
// WEBPACK FOOTER
// ./~/reta/rules.js
// module id = 621
// module chunks = 0